import { put, takeLatest } from "redux-saga/effects";
import {
  fetchPDPInitialLoadSuccess,
  fetchPDPBidCenterDataSuccess,
  fetchPDPLatestBidCenterDataSuccess,
  fetchLatestBidCenterDetailsFaliure,
  fetchInvestmentCalculatorSuccess,
  setPdpError,
} from "./pdpSlice";
import {
  getPDPInitData,
  getInvestmentData,
  getCMS,
  getPropertyDetails,
  getBidCenterDetails,
  getLatestBidCenter,
} from "@/api/PDP";
import { setListingId } from "@/bidFeature/propertyDetailSlice";

export function* fetchPDPInitSaga(action) {
  let response = null;
  response = yield getPDPInitData(action.payload);
  if (response && !response.errorMessage) {
    yield put(fetchPDPInitialLoadSuccess(response));
    yield put(setListingId(response?.propertyDetails));
  } else if (response && response.errorMessage) {
    // API returned an error (404, invalid property type, etc.) — store the response
    // so residential PDP can detect propertyDetails === null
    yield put(fetchPDPInitialLoadSuccess(response));
    yield put(setPdpError("Failed to load property details"));
  } else {
    // Null response (network failure)
    yield put(fetchPDPInitialLoadSuccess({ propertyDetails: null }));
    yield put(setPdpError("Failed to load property details"));
  }
}
export function* fetchInvestCalSaga(action) {
  try {
    if (action.payload) {
      const investmentData = yield getInvestmentData(action.payload);
      if (investmentData) {
        yield put(fetchInvestmentCalculatorSuccess(investmentData));
      }
    }
  } catch(e) {
    console.log(e);
  }
}

export function* watchFetchPDPInitSaga() {
  yield takeLatest("pdp/fetchPDPInitialLoad", fetchPDPInitSaga);
  yield takeLatest("pdp/fetchInvestCalLoad", fetchInvestCalSaga);
}

export function* fetchLatestBidDetailsSaga({ payload }) {
  let response = null;

  response = yield getLatestBidCenter(payload);

  if (response) {
    yield put(fetchPDPLatestBidCenterDataSuccess(response));
  } else {
    yield put(
      fetchLatestBidCenterDetailsFaliure(
        "BidWizard property details request failed!"
      )
    );
  }
}
export function* watchFetchLatestBidDetailsSaga() {
  yield takeLatest(
    "pdp/fetchPDPLatestBidCenterData",
    fetchLatestBidDetailsSaga
  );
}


export function* fetchBidDetailsSaga({ payload }) {
  let response = null;

  response = yield getBidCenterDetails(payload);

  if (response) {
    yield put(fetchPDPBidCenterDataSuccess(response));
  } else {
    yield put(
      fetchLatestBidCenterDetailsFaliure(
        "BidWizard property details request failed!"
      )
    );
  }
}
export function* watchFetchBidDetailsSaga() {
  yield takeLatest("pdp/fetchPDPBidCenterData", fetchBidDetailsSaga);
}
